import CardWithThumbnail from "@/components/ui/card-with-thumbnail";

export default function About() {
  return (
    <>
      <section className="relative flex flex-col p-8 pt-16 md:pl-[21.7rem] md:pt-[21.2rem] lg:pr-28">
        <div className="absolute left-[21rem] top-0 hidden h-full w-[4px] bg-gray-300 md:block" />
        <hr className="absolute left-0 top-[8.5rem] w-full border-t border-dashed border-gray-300 md:top-[21rem]" />
        <h1 className="left-[3.5rem] top-[12.6rem] text-7xl font-light md:absolute ">
          Hi there, I&apos;m
        </h1>
        <h1 className="left-[3.5rem] top-[16.6rem] text-7xl font-light md:absolute ">
          PARKER CAI <br />
        </h1>
        <div className="max-w-4xl">
          <span className="block pl-1 text-xl font-normal">
            I&apos;m an
            <br />
            Creative Technologist<br />
            Specialized in AI x 3D<br />
            currently working on my MSCS @ Northeastern
          </span>
          <p className="pl-0"></p>
          <h2 className="mt-4 text-4xl font-light text-foreground-500">
            BACKGROUND
          </h2>
          <div className="mt-4">
            <h3 className="text-bold text-xl font-semibold">
              Architecture and Design
            </h3>
            <p className="pl-0">
              From a young age, I was captivated by architecture&apos;s power to
              transform imagination into reality.
            </p>
            <ul className="mt-1 list-none  text-foreground-500">
              <li>
                This passion led me to train as an architect at Illinois
                Institute of Technology and work at renowned firms like
                Skidmore, Owings &amp; Merrill and Gensler, before co-founding
                OVA.DESIGN, a studio focused on Metaverse experience
                design.
              </li>
              <li></li>
            </ul>
            <h3 className="text-bold text-xl font-semibold">
              Computer Science &amp; AI
            </h3>
            <p className="pl-0">
              I&apos;m currently pursuing my Master&apos;s in Computer Science
              at Northeastern University (GPA 3.9), with a focus on computer
              vision and cloud computing. My background in architecture gives
              me a unique lens for approaching software — I think spatially,
              design systematically, and build things people actually want to
              use.
            </p>
            <ul className="mt-1 list-none  text-foreground-500">
              <li>
                Recent work includes Cria Design, a text-to-3D parametric CAD
                tool powered by AI, and WhisperO, an open-source voice
                dictation app with GPU-accelerated transcription.
              </li>
            </ul>
          </div>
          <h2 className="mt-4 text-4xl font-light text-foreground-500">
            PROJECTS
          </h2>
          <div className="flex flex-col items-center gap-2 p-1 sm:items-start lg:flex-row lg:flex-wrap">
            <CardWithThumbnail
              title="Cria Design"
              description="Text-to-3D parametric CAD tool. AI-powered modeling with real-time collaboration and CLI-first workflow."
              imageLink="/images/website/CriaDesign_320x568.mp4"
              githubUrl="https://github.com/parkercai/cria-design"
              websiteUrl="https://cria.design"
              stackLabels={[
                "React",
                "Three.js",
                "React-three/fiber",
                "Fastify",
                "Blender",
                "OpenAI API",
                "AWS EC2",
              ]}
            />
            <CardWithThumbnail
              title="WhisperO"
              description="Open-source voice dictation app with GPU-accelerated transcription. Local-first, cross-platform."
              imageLink="/images/website/WhisperO_320x568.mp4"
              githubUrl="https://github.com/parkercai/WhisperO"
              websiteUrl="https://github.com/parkercai/WhisperO"
              stackLabels={[
                "Python",
                "faster-whisper",
                "PyTorch",
                "CUDA",
                "PyInstaller",
              ]}
            />
            <CardWithThumbnail
              title="OVA.DESIGN website"
              description="3D interactive website for OVA.DESIGN with CMS admin panel."
              imageLink="/images/website/OVA_Website_320x568.mp4"
              websiteUrl="https://ova.design"
              stackLabels={[
                "TypeScript",
                "Three.js",
                "Next.js",
                "Tailwind CSS",
                "React-three/fiber",
                "Sanity",
              ]}
            />
            <CardWithThumbnail
              title="Parallel AI web app"
              description="Simple AI summarizer with colorful UI. Works with Google Gemini and ChatGPT APIs."
              imageLink="/images/website/ParallelAI_320x568.mp4"
              githubUrl="https://github.com/parkercai/parallel-ai"
              websiteUrl="https://parallel.ai.vercel.app/"
              stackLabels={[
                "TypeScript",
                "Next.js",
                "Tailwind CSS",
                "Shadcn UI",
                "Postgres DB",
                "Gemini API",
                "ChatGPT API",
              ]}
            />
          </div>

          <div className="mt-4">
            <h2 className="mt-4 text-4xl font-light text-foreground-500">
              HOBBIES
            </h2>
            <h3 className="text-bold text-xl font-semibold">3D Printing</h3>
            <p className="pl-0">
              I like to 3D print. I have design and printed a variety of
              objects.
            </p>
            <ul className="mt-1 list-none  text-foreground-500">
              <li></li>
              <li></li>
            </ul>
          </div>
          <h2 className="mt-4 text-4xl font-light text-foreground-500">
            SKILLS
          </h2>
          <div>
            <p className="pl-0">Programming Languages &amp; Frameworks:</p>
            <ul className="mt-1 list-none  text-foreground-500">
              <li>
                HTML/CSS, Tailwind CSS, JavaScript, TypeScript, React, Node.js,
                Next.js, Three.js, Python, FastAPI, Django, Express, Java, C++,
                SQL, Git
              </li>
            </ul>
          </div>
          <div>
            <p className="pl-0">AI &amp; Machine Learning:</p>
            <ul className="mt-1 list-none  text-foreground-500">
              <li>
                PyTorch, OpenCV, Hugging Face Transformers, LangChain, RAG
                Pipelines, Stable Diffusion (ComfyUI, LoRA, Checkpoint
                Training), OpenAI API, Gemini API
              </li>
            </ul>
          </div>
          <div>
            <p className="pl-0">Cloud &amp; Infrastructure:</p>
            <ul className="mt-1 list-none  text-foreground-500">
              <li>
                AWS (EC2, S3), Docker, Nginx, Linux, systemd, CUDA
              </li>
            </ul>
          </div>
          <div>
            <p className="pl-0">Parametric Design &amp; Visual Programming:</p>
            <ul className="mt-1 list-none  text-foreground-500">
              <li>
                Blender Geometry Nodes, Grasshopper, Dynamo (proficient in
                various plug-ins for geometry and topology optimizations, form
                finding, performance analysis, animations etc.)
              </li>
            </ul>
          </div>
          <div>
            <p className="pl-0">3D Modeling &amp; Visualization:</p>
            <ul className="mt-1 list-none  text-foreground-500">
              <li>
                Blender, Rhinoceros 3D, Autodesk AEC Collection (Revit, AutoCAD,
                3ds Max), Cycles, V-Ray, KeyShot, Enscape3D, Unity, Unreal
                Engine, Adobe Creative Cloud (Photoshop, InDesign, Illustrator,
                Lightroom, Premiere Pro)
              </li>
            </ul>
          </div>
          <div>
            <p className="pl-0">Embedded &amp; Fabrication:</p>
            <ul className="mt-1 list-none  text-foreground-500">
              <li>
                Raspberry Pi, Arduino, NVIDIA Jetson, 3D Printing (FDM, SLA),
                CNC
              </li>
            </ul>
          </div>
        </div>
      </section>
    </>
  );
}

